import * as React from 'react';
import YadoItemContentView from './views/YadoItemContentView';
import YadoItemResort from './YadoItemResort';
import YadoItemMapLink from './YadoItemMapLink';
import YadoResortSection from './YadoResortSection';
import YadoResortSectionTitleView from './views/YadoResortSectionTitleView';
import { IYado, IResort, ICurrency } from '../types';
import { flatten } from '../../utils/commonHelper';
import { resortSectionTitle, sortResorts } from '../helpers';
import t from '../locales';
import styled from "styled-components";

const TitleView = styled.h2`
  line-height: 1.7;
`;

interface IProps {
  yado: IYado;
  currency: ICurrency;
}

const YadoItemContent: React.FC<IProps> = (props) => {
  const { yado, currency } = props;
  const { resorts } = yado;
  const closeResorts = sortResorts(resorts);
  const sorted = flatten(Object.values(closeResorts));
  const firstResort = sorted[0];
  const resortCount = sorted.length - 1;

  const resortTitle = resortSectionTitle([firstResort]);
  return (
    <YadoItemContentView>
      <TitleView className="title">{yado.name}</TitleView>
      <p className="title-en">{yado.name_en}</p>
      <YadoItemMapLink yado={yado} />
      <React.Fragment>
        {resortTitle && <YadoResortSectionTitleView>{resortTitle}</YadoResortSectionTitleView>}
        {firstResort &&
          <YadoItemResort
            name={firstResort.name}
            code={firstResort.code}
            currency={currency}
            lift_min_price={firstResort.lift_min_price}
            rental_min_price={firstResort.rental_min_price} />}
      </React.Fragment>
      {resortCount > 0 &&
        <div className="resort-more">
          <span>{t.otherResortCount({ count: resortCount })}</span>
          <div className="resort-more-modal">
            <YadoResortSection currency={currency} resorts={closeResorts.adjacent} exclude={[firstResort]} />
            <YadoResortSection currency={currency} resorts={closeResorts.walk} exclude={[firstResort]} />
            <YadoResortSection currency={currency} resorts={closeResorts.shuttleBus} exclude={[firstResort]} />
          </div>
        </div>
      }
    </YadoItemContentView>
  );
}

export default YadoItemContent;
